import(/* webpackMode: "eager" */ "/codebuild/output/src3785830148/src/4takeaway-storefront/src/app/[locale]/error.tsx")